export default "__VITE_ASSET__51STiQCW__"